import { faLinkSimpleSlash } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";

import { DeviceActions } from "@skydio/rivet-entities";

import type { DeviceActionsItem } from "@skydio/rivet-entities";

export const UnclaimDeviceMenuItem = (props: { handler: () => void }) => {
  const actionsItems: DeviceActionsItem[] = useMemo(
    () => [
      {
        key: "unclaim",
        onSelectHandler: props.handler,
        content: (
          <div className="text-red-500">
            <FontAwesomeIcon width={14} icon={faLinkSimpleSlash} /> Unclaim Device
          </div>
        ),
      },
    ],
    [props.handler]
  );

  return <DeviceActions items={actionsItems} />;
};
